import { render } from "./GroupBuy.vue?vue&type=template&id=40100164&scoped=true&ts=true"
import script from "./GroupBuy.vue?vue&type=script&lang=ts"
export * from "./GroupBuy.vue?vue&type=script&lang=ts"

import "./GroupBuy.vue?vue&type=style&index=0&id=40100164&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40100164"]])

export default __exports__